// extracted by mini-css-extract-plugin
export var cHeading = "styles-module--cHeading--U3OgA";
export var cHeadingLarge = "styles-module--cHeadingLarge--BDC8K";
export var cLastChar = "styles-module--cLastChar--YqVaG";
export var cPost = "styles-module--cPost--D262j";
export var cPre = "styles-module--cPre--Xyeao";
export var cWrapper = "styles-module--cWrapper--jVRkS";